import { DateTime } from "luxon"

export const AIKALaunchDate = DateTime.fromObject({
  year: 2024,
  month: 10,
  day: 16,
})
